export const BIA_ENABLED = process.env.REACT_APP_BIA_ENABLED === 'true'
